import { Client } from '@/pages/user/api';
let apiPrefix = 'portal';

/**
 * 校验星云验证码
 */
export const checkBpCaptcha = async (data: any): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/enterprise/checkBpCaptcha',
    data,
  });
};

/**
 * 查询企业信息
 */
export const GetenterpriseDetail = async (): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/enterprise/detail',
  });
};

/**
 * 3.4 修改企业信息
 */
export const UpdateenterpriseDetail = async (data: any): Promise<any | null> => {
  return await Client.put<any>({
    url: apiPrefix + '/enterprise/update',
    data,
  });
};

/**
 * 3.5 查询企业人员
 */
export const GetenterprisePage = async (data: any): Promise<any | null> => {
  return await Client.get<any>({
    url: apiPrefix + '/auth/enterprise/user/pageQuery',
    data,
  });
};

/**
 * 3.6 添加企业人员
 */
export const CreateEnterpriseUser = async (data: any): Promise<any | null> => {
  return await Client.post<any>({
    url: apiPrefix + '/auth/enterprise/user/create',
    data,
  });
};

/**
 * 3.7 企业人员重置密码
 */
export const ResetPassword = async (data: any): Promise<any | null> => {
  return await Client.put<any>({
    url: apiPrefix + '/auth/enterprise/user/resetPassword',
    data,
  });
};
/**
 * 3.8 企业人员注销
 */
export const Cancellation = async (data: any): Promise<any | null> => {
  return await Client.put<any>({
    url: apiPrefix + '/auth/enterprise/user/cancellation',
    data,
  });
};
/**
 * 3.9 修改当前登录用户信息
 */
export const UpdateCurrentUser = async (data: any): Promise<any | null> => {
  return await Client.put<any>({
    url: apiPrefix + '/auth/enterprise/user/update',
    data,
  });
};
/**
 * 3.10 修改当前登录用户密码
 */
export const UpdateCurrentUserPwd = async (data: any): Promise<any | null> => {
  return await Client.put<any>({
    url: apiPrefix + '/auth/enterprise/user/modifyPassword',
    data,
  });
};
